import React from 'react';
import { BeatLoader } from 'react-spinners';

export default function Loader() {
  return (
    <div
      style={{ paddingTop: 10, paddingBottom: 10 }}
      className="d-block text-center px-12"
    >
      <BeatLoader color="#ffffff" />
    </div>
  );
}
